export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/foundation-icons-a02a0dbbb4c161b4e2f1c5b3322f93e9.svg";